import { ViewAllEvents } from "../../data-model/viewAllEvents";
import { API_ENDPOINTS } from "../../enums/apiUrls";
import { logError } from "../../utils/customLogger";

export interface GetAuditTrialOverviewPayload {
  order_id: string;
}

export const getViewAllAuditTrail = async (
  payload: GetAuditTrialOverviewPayload,
) => {
  try {
    const response = await fetch(API_ENDPOINTS.VIEW_ALL_AUDIT_TRAIL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error("Failed to fetch audit trial overview");
    }

    const data = await response.json();
    return data as ViewAllEvents;
  } catch (error) {
    logError(error as Error, "Error in getViewAllAuditTrail");
    throw error;
  }
};
